import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__ior_fyjbup3afgshzn5jz42zbn7gai/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.0_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__ior_fyjbup3afgshzn5jz42zbn7gai/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-authenticated-middleware": () => import("/app/src/middleware/admin-authenticated-middleware.ts"),
  "app-authenticated-middleware": () => import("/app/src/middleware/app-authenticated-middleware.ts"),
  "redirect-middleware": () => import("/app/src/middleware/redirect-middleware.ts"),
  "redirect-to-sign-middleware": () => import("/app/src/middleware/redirect-to-sign-middleware.ts"),
  "select-product-list-middleware": () => import("/app/src/middleware/select-product-list-middleware.ts"),
  "set-auth-middleware": () => import("/app/src/middleware/set-auth-middleware.ts"),
  "view-permissions-middleware": () => import("/app/src/middleware/view-permissions-middleware.ts")
}